import {
  ContentElementInfobox as ContentElementInfoboxDefault,
  composeStyles,
} from '@vgn-medien-holding/vgn-fe-components';
import elementStyle from './styles/default';

export default function ContentElementInfobox(element) {
  return (
    <div>
      <ContentElementInfoboxDefault
        element={element}
        classProps={composeStyles(
          elementStyle,
          element?.style === 'style_2' ? { container: 'pl-8 border-primary' } : {},
        )}
      />
    </div>
  );
}
